class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-content',
      }
    ];

    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then(async (response) => {
        const text = await response.text();

        /* 🔴 HANDLE INVENTORY / QUANTITY ERROR */
        if (!response.ok) {
          const errorState = JSON.parse(text);
          this.showLineItemError(line, errorState.description);
          this.disableLoading();
          return;
        }

        const parsedState = JSON.parse(text);

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) {
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(line, parsedState.item_count);
        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  /* ✅ SHOW LINE ITEM ERROR */
  showLineItemError(line, message) {
    const errorWrapper =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (!errorWrapper) return;

    const errorText = errorWrapper.querySelector('.cart-item__error-text');
    if (!errorText) return;

    errorText.textContent = message;
    errorWrapper.removeAttribute('hidden');
    errorWrapper.setAttribute('aria-hidden', 'false');
  }

  updateLiveRegions(line, itemCount) {
    /* ✅ HIDE ERROR WHEN FIXED */
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      lineItemError.setAttribute('hidden', true);
    }

    this.currentItemCount = itemCount;

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');

    if (!cartStatus) return;

    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');

    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const overlays = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay, #CartDrawer-Item-${line} .loading-overlay`
    );

    overlays.forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');

    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
  }
}

customElements.define('cart-items', CartItems);
